module.exports = __webpack_public_path__ + "img/storico-alertmsg.b6f3965b.png";